<template>
  <div class="war-room-category-badge-topic">
    <div v-for="topic in topics" :key="topic.id" class="war-room-category-badge-topic__cell">
      <NuxtLink
        v-slot="{ href, navigate }"
        :to="{ name: 'war-room-topics-topicSlug-posts', params: { topicSlug: topic.slug } }"
        custom
      >
        <a :href="href" :title="topic.name" class="war-room-category-badge-topic__link" @click.stop="navigate">
          {{ topic.emoji }}
          <span v-if="topics.length === 1" class="war-room-category-badge-topic__topic-name">{{ topic.name }}</span>
        </a>
      </NuxtLink>
      <ClientOnly v-if="topics.length > 1">
        <div class="war-room-category-badge-topic__tooltip">
          <TooltipArrow class="war-room-category-badge-topic__tooltip-arrow" />
          <div class="war-room-category-badge-topic__tooltip-info">
            {{ topic.emoji }}
            {{ topic.name }}
          </div>
        </div>
      </ClientOnly>
    </div>
  </div>
</template>

<script lang="ts">
import type { PropOptions } from 'vue';
import Vue from 'vue';
import type { IPostTopic } from '@/types/community';
import TooltipArrow from '@/components/partials/war-room/WarRoomCategoryBadge/images/tooltip-arrow.vue.svg';

export default Vue.extend({
  name: 'WarRoomCategoryBadgeTopic',
  components: {
    TooltipArrow,
  },
  props: {
    topics: {
      type: Array,
      required: true,
    } as PropOptions<IPostTopic[]>,
  },
});
</script>

<style scoped lang="scss">
.war-room-category-badge-topic {
  $this: &;

  display: grid;
  grid-column-gap: 4px;
  grid-auto-flow: column;
  background: var(--theme-color-over-card);
  border-radius: 4px;
  padding: 3px 6px;

  @include mq('md') {
    padding: 5px 6px;
  }

  &__cell {
    position: relative;
    display: inline-flex;
    height: 16px;
  }

  &__tooltip {
    position: absolute;
    bottom: -3px;
    left: 50%;
    transform: translate(-50%, 100%);
    border-radius: 6px;
    background: var(--gray-80);
    padding: 3px 6px 4px;
    opacity: 0;
    will-change: opacity;
    transition: opacity 0.1s ease-in-out;
  }

  &__tooltip-arrow {
    position: absolute;
    top: 1px;
    left: 50%;
    transform: translate(-50%, -100%);
  }

  &__tooltip-info {
    @include caption2-semibold;

    color: rgba(var(--white));
    display: flex;
    align-items: center;
    white-space: nowrap;
  }

  &__link {
    font-family: var(--font-family-emoji);
    font-size: 13px;
    text-decoration: none;
    line-height: 1.2;

    &:hover {
      ~ #{$this}__tooltip {
        opacity: 1;
      }
    }
  }

  &__topic-name {
    display: none;
    font-family: var(--font-family);

    @include mq('md') {
      @include caption1;

      color: var(--theme-color-sub-text);
      display: inline;
      margin-left: 4px;
    }
  }
}
</style>
